import serves from "@/http";
// import * as storage from "../storage";
import * as types from "./mutations-type";
export const ActionCadastro = ({dispatch},payload)=>{
    return serves.tomadorbackup.cadastra(payload).then(res => {
        dispatch('ActionSetListaTomador',res)
    }).catch(err => {
        dispatch('ActionSetListaTomador',err)
    })
}


export const ActionSetListaTomador = ({commit},payload) =>{
    commit(types.SET_TOMADOR,payload)
}


